module.exports = __webpack_public_path__ + "static/media/dogshotel.3602ad5a.png";